<button type="button" (click)="onButtonClicked()" class={{this.class}} [disabled]="isDisabled">
    <ng-content></ng-content>
</button>